function projectRequirementsArray() {

    return [
        {
            optionId: '1',
            text: 'Bridges',
            value: 'bridges'
        },
        {
            optionId: '2',
            text: 'Public Road/Streets',
            value: 'publicRoadAndStreets'
        },
        {
            optionId: '3',
            text: 'Dams/Tunnels',
            value: 'damsAndTunnels'
        },
        {
            optionId: '4',
            text: 'Airports',
            value: 'airports'
        },
        {
            optionId: '5',
            text: 'Amusement Parks/Rides',
            value: 'amusementParksAndRides'
        },
        {
            optionId: '6',
            text: 'Oil/Gas/Chemical Industries',
            value: 'oilGasAndChemical'
        },
        {
            optionId: '7',
            text: 'Power Plants',
            value: 'powerPlants'
        },
        {
            optionId: '8',
            text: 'Cannabis',
            value: 'cannabis',
        },
        {
            optionId: '9',
            text: 'Railroads',
            value: 'railRoads'
        },
        {
            optionId: '12',
            text: 'Condo Conversion',
            value: 'condoConversion'
        },
        {
            optionId: '13',
            text: 'Schools',
            value: 'schools'
        },
        {
            optionId: '14',
            text: 'Solar Energy',
            value: 'solarEnergy'
        },
        {
            optionId: '11',
            text: 'None of the above',
            value: false,
            disableOther: true,
        }
    ];
}

export default projectRequirementsArray;
